module.exports = __webpack_public_path__ + "img/taut.e5460762.jpeg";